import { SvgIconBase, } from "./Base";


export const Dark = ({
	fill = "currentColor",
	scale = 1,
}: { fill?: string; scale?: number; }) => {
	return (
		<SvgIconBase width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Dark Mode" scale={scale}>
			<title>Dark Mode</title>
			{/* Crescent moon shape */}
			<path
				d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
				fill={fill}
			/>
		</SvgIconBase>
	);
};

